import { useState, useLayoutEffect } from 'react'

export const useWindowSize = () => {
  const [size, setSize] = useState([0, 0])
  useLayoutEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth, window.innerHeight])
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])
  return [size]
}

export const useDetectedDevice = () => {
  const [device, setDevice] = useState('browser')
  useLayoutEffect(() => {
    const updateSize = () => {
      if (window.innerWidth <= 414) {
        setDevice('phone')
      } else if (window.innerWidth <= 768) {
        setDevice('tablet')
      } else {
        setDevice('browser')
      }
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])
  return [device]
}
